<script setup lang="ts">
import type { Component } from 'vue'
import { cursorPagination } from '~/data/pagination'

defineProps<{
  resource: {
    data?: {
      next?: string | null | undefined
      previous?: string | null | undefined
    }
  }
  is: Component<{
    goNext?: () => void
    goPrevious?: () => void
  }>
}>()
const cursor = defineModel<string | null>()
</script>

<template>
  <component
    :is
    :go-next="resource.data?.next ? () => cursor = cursorPagination.next(resource) : undefined"
    :go-previous="resource.data?.previous ? () => cursor = cursorPagination.previous(resource) : undefined"
  >
    <slot />
  </component>
</template>
